<template>
  <section class="result">
    <div class="inner">
      <div class="result__content">
        <div class="result__title">
          <p class="result__title__you">
            きみは…
          </p>
          <h1 class="result__title__label">
            <img
              :src="require(`@/assets/images/${resultCode}-title.svg`)"
              :width="resultNameWidth"
              height="94"
              :alt="resultName"
            >
          </h1>
        </div>
        <div class="result__illust">
          <img
            :src="require(`@/assets/images/${resultCode}-illust.png`)"
            width="270"
            height="270"
            alt=""
          >
        </div>
        <p class="result__caption">
          <slot />
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ResultType',
  props: {
    resultCode: {
      type: String,
      default: ''
    },
    resultName: {
      type: String,
      default: ''
    },
    resultNameWidth: {
      type: String,
      default: ''
    },
  }
}
</script>

<style lang="scss" scoped>
@use "@/assets/scss/foundation/config/colors";
@use "@/assets/scss/foundation/config/mediaquery";
@use "@/assets/scss/foundation/mixin";

@keyframes inview {
  from {
    opacity: 0;
    transform: translateY(5%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.result {
  padding: 32px 0 60px;
  background: colors.$color-bg-sub;
  @include mediaquery.minMediaMajor {
    padding: 120px 0 130px;
  }
}

.result__content {
  @include mediaquery.minMediaLarge {
    display: grid;
    grid-template-columns: 500px 1fr;
    grid-template-rows: 180px auto;
    grid-template-areas:
      "illust title"
      "illust caption";
    gap: 20px 90px;
  }
}

.result__illust {
  grid-area: illust;
  text-align: center;
  margin-top: 20px;
  animation: inview .5s .5s both;
  @include mediaquery.minMediaLarge {
    margin-top: 0;
  }

  img {
    width: 100%;
    height: auto;
  }
}

.result__title {
  grid-area: title;
}

.result__title__you {
  font-size: 1.8rem;
  font-weight: bold;
  @include mediaquery.minMediaMajor {
    font-size: 2.4rem;
  }
}

.result__title__label {
  margin: -10px -50px 0;
  text-align: center;
  @include mediaquery.minMediaLarge {
    margin: -15px 0 0;
    text-align: left;
  }

  img {
    max-width: unset;
    @include mediaquery.minMediaMajor {
      width: auto;
      height: 155px;
    }
  }
}

.result__caption {
  grid-area: caption;
  margin-top: 32px;
  @include mediaquery.minMediaLarge {
    margin-top: 0;
  }
}
</style>